import { useSetAtom } from "jotai";
import {ConfirmDialogAtom} from "../pages/project/atoms";

const useConfirm = (titleDefault, messageDefault, confirmDefault, cancelDefault) => {
  const setDialog = useSetAtom(ConfirmDialogAtom);

  const confirm = (props) =>
    new Promise((resolve) => {
      const {title, message, confirmText, cancelText} = props || {};
      setDialog({
        open: true,
        title: title || titleDefault || "Are you sure you wan to take this action?",
        message: message || messageDefault || null,
        confirmText: confirmText || confirmDefault || "Confirm",
        cancelText: cancelText || cancelDefault || "Cancel",
        resolve,
      });
    });

  return confirm;
};

export default useConfirm;
